<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows wrap-scrollbar wrap-scrollbar__clients">
          <v-breadcrumbs divider="/" large disabled="false" class="pa-0">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item v-if="item.klient && !item.spolupracovnik">
              <v-btn color="blue" outline @click="gotoall" class="ma-0">Klienti</v-btn>
            </v-breadcrumbs-item>
            <v-breadcrumbs-item v-else-if="item.spolupracovnik">
              <v-btn color="blue" outline @click="gotoall" class="ma-0">Spolupracovníci</v-btn>
            </v-breadcrumbs-item>
            <v-breadcrumbs-item>
              {{item.nazev_osoby}}
            </v-breadcrumbs-item>
          </v-breadcrumbs>
          <v-card-text :class="{'pl-1 pr-1': $vuetify.breakpoint.smAndDown}">
            <v-tabs v-model="activeTab" color="transparent" slot="extension" class="mlm10">
              <v-tab v-for="(tab, n) in tabs" :key="n" ripple>
                {{tabsText[n]}}
              </v-tab>
            </v-tabs>
            <div>
              <v-card color="grey lighten-5" class="pa-1 mt-4 elevation-0 no__radius">
                <v-card-text class="pa-0">
                  <v-tabs-items touchless v-model="activeTab">
                    <v-tab-item v-for="(t, n) in tabs" :key="n">

                      <Klient :id="id" v-model="item" v-if="t=='informace'"></Klient>
                      <JednorazoveNakupy :id="id" v-if="t=='jednorazove-nakupy'"></JednorazoveNakupy>
                      <SporiciProgramy :id="id" v-if="t=='sporici-programy'" :sporici_program="sporici_program"></SporiciProgramy>
                      <ElektronickaPenezenka :id="id" v-if="t=='elektronicka-penezenka'"></ElektronickaPenezenka>
                      <ObchodyProvizeKlient :id="id" v-if="t=='obchody'"></ObchodyProvizeKlient>
                      <Pozice :id="id" v-if="t=='pozice'"></Pozice>
                      <NadrizeniSpolupracovnici :id="id" v-if="t=='nadrizeni-spolupracovnici'"></NadrizeniSpolupracovnici>

                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import Klient from '@/pages/Klienti/Klient'
import JednorazoveNakupy from '@/pages/Klienti/JednorazoveNakupy'
import SporiciProgramy from '@/pages/Klienti/SporiciProgramy'
import ObchodyProvizeKlient from '@/pages/Klienti/ObchodyProvizeKlient'
import Pozice from '@/pages/Klienti/Pozice'
import ElektronickaPenezenka from '@/pages/Klienti/ElektronickaPenezenka'
import NadrizeniSpolupracovnici from '@/pages/Klienti/NadrizeniSpolupracovnici'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      // Item variables start
      editMode: false,
      item: {},
      dialogUpdate: false,
      updateItem: {},
      dialogRemove: false,
      removeItem: {},
      updating: false,
      removing: false,
      // Item variables end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      activeTab: 0,
      tabs: [ 'informace' ],
      tabsText: [ 'Informace o klientovi' ]
    }
  },
  watch: {
    activeTab () {
      if (!this.loading) {
        var $detailSuffix = "";
        if (typeof this.$props.sporici_program != "undefined" && this.$props.sporici_program != null && this.tabs[this.activeTab] == 'sporici-programy')
          $detailSuffix = "/" + this.$props.sporici_program;
        this.$router.push({ path: "/klienti/{0}/{1}{2}".format(this.$props.id, this.tabs[this.activeTab], $detailSuffix) });
      }
    }
  },
  props: {
    id: String,
    tab: String,
    sporici_program: String
  },
  mounted: function() {
    if (this.$props.tab.length > 0) {
      this.activeTab = this.tabs.indexOf(this.$props.tab);
    }
    this.load();
  },
  methods: {
    load () {
      window.api.get("osoby/" + this.$props.id).then((_body) => {
        this.item = _body;
        this.loading = false;
        this.tabs = [ "informace" ];
        if (this.item.spolupracovnik) {
          this.tabs = this.tabs.concat([ 'jednorazove-nakupy', 'sporici-programy', 'elektronicka-penezenka', 'obchody', 'pozice', 'nadrizeni-spolupracovnici' ]);
          this.tabsText = this.tabsText.concat([ 'Jednorázové nákupy', 'Spořící programy', 'El. peněženka', 'Obchody a provize', 'Pozice', 'Nadřízení spolupracovníci' ]);
        }
        else if (this.item.klient) {
          this.tabs = this.tabs.concat([ 'jednorazove-nakupy', 'sporici-programy', 'elektronicka-penezenka' ]);
          this.tabsText = this.tabsText.concat([ 'Jednorázové nákupy', 'Spořící programy', 'El. peněženka' ]);
        }
        if (this.$props.tab.length > 0) {
          this.activeTab = this.tabs.indexOf(this.$props.tab);
        }
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    editClick () {
      this.updateItem = window.th.copy(this.item);
      this.editMode = true;
    },
    edit () {
      this.updating = true;
      window.api.put("osoby/" + this.$props.id, this.updateItem).then((_body) => {
        if (_body.updated) {
          this.item = window.th.copy(this.updateItem);
          this.editMode = false;
        }
        this.updating = false;
      }).catch((err) => {
        console.log(err);
        this.updating = false;
      });
    },
    removeClick () {
      this.removeItem = window.th.copy(this.item);
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.api.delete("osoby/" + this.$props.id).then((_body) => {
        if (_body.deleted) {
          this.$router.push({ path: "/klienti" })
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    gotoall () {
      if (this.item.klient)
        this.$router.push({ path: "/klienti" });
      else if (this.item.spolupracovnik)
        this.$router.push({ path: "/spolupracovnici" });
    }
  },
  components: {
    Klient, JednorazoveNakupy, SporiciProgramy, ObchodyProvizeKlient, Pozice, ElektronickaPenezenka, NadrizeniSpolupracovnici
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/KlientiSpolupracovnici/KlientDetail.vue